export default __webpack_public_path__ + "static/media/EAST1050.34I-34180_-18427_0.850974c0.jpg";